import React, { memo, useCallback, useMemo, useState } from 'react';

import { Modal, Table } from '@components/common';

import { useQueryCommissionHistory } from '@hooks/organisation/useQueryCommissionHistory';

import { MODAL_WIDTH_480 } from '@constants/modals';

import CommissionSettingsForm from './CommissionSettingsForm';
import getColumns from './utils';

import styles from './AssetOwnerSettings.module.scss';

interface IAssetOwnerSettingsProps {
	organisationId?: string;
	isEditMode?: boolean;
}

const TABLE_HEIGHT = '55vh';

const AssetOwnerSettings = ({
	organisationId,
	isEditMode,
}: IAssetOwnerSettingsProps) => {
	const [isCommissionForm, setIsCommissionForm] = useState(false);
	const [isDirtyForm, setIsDirtyForm] = useState(false);

	const openCommissionForm = useCallback(() => setIsCommissionForm(true), []);
	const closeCommissionForm = useCallback(() => setIsCommissionForm(false), []);

	const { commissionHistory, isLoadingCommissionHistory } = useQueryCommissionHistory(organisationId);

	const columns = useMemo(() => getColumns(), []);

	return (
		<div className={styles.settingsContainer}>
			<Modal
				isConfirmDialogNeededOnClose
				isDirtyForm={isDirtyForm}
				isOpen={isCommissionForm}
				onClose={closeCommissionForm}
				title='Add commission type'
				width={MODAL_WIDTH_480}
			>
				<CommissionSettingsForm
					closeCommissionForm={closeCommissionForm}
					onClose={closeCommissionForm}
					organisationId={organisationId}
					setIsDirtyForm={setIsDirtyForm}
				/>
			</Modal>
			<Table
				addText='Add commission'
				addTooltipText='Add commission'
				columns={columns}
				data={commissionHistory}
				height='unset'
				isCreatable={isEditMode}
				isEditAccess
				isLoading={isLoadingCommissionHistory}
				isWithoutCheckbox
				isWithoutDeleteAction
				isWithoutFilter
				maxHeight={TABLE_HEIGHT}
				toggleAddModal={openCommissionForm}
			/>
		</div>
	);
};

export default memo(AssetOwnerSettings);
